import React from 'react'

export default function Add({ onSubmit }) {
  return (
    <button type="button" className='dome-btn dome-btn-base dome-btn-dark-green' onClick={onSubmit}>
      add
    </button>
  )
}
